/**
 * Mote de cada mês.
 *
 * Uma linha por mês, escrita para este produto, que abre a divisória: o mês em
 * letra grande, um traço e a frase. É o que tira a divisória do lugar de "página
 * de separação" e a transforma em abertura de capítulo — a primeira coisa que a
 * pessoa vê ao virar para março.
 *
 * Regras do texto (valem para as doze):
 *
 * - **curto** — cabe numa linha em A5 e em A6, porque a faixa do título é medida
 *   pelo motor e uma frase longa empurraria o corpo da página;
 * - **do clima do mês no Brasil**, não de um hemisfério imaginário: outono em
 *   abril, festa junina em junho, chuva em outubro;
 * - **sem clichê de agenda**: nada de "novo mês, nova chance". A frase diz uma
 *   coisa concreta sobre o mês — e serve para quem está começando o mês em
 *   qualquer dia dele.
 */
export const MOTES_DO_MES = [
    'Ano novo, página nova: comece pequeno e continue.',
    'O carnaval passa; o que você escreveu fica.',
    'Março abre as portas do ano de verdade.',
    'Outono chega devagar: menos pressa, mais atenção.',
    'Maio pede aconchego e contas em ordem.',
    'Junho é das festas, do milho e da lã.',
    'Férias são para descansar de verdade.',
    'Agosto é o mês do vento e das decisões.',
    'Setembro floresce onde alguém plantou antes.',
    'Outubro traz chuva e vontade de recomeçar.',
    'Novembro é para terminar o que já começou.',
    'Dezembro é colheita: olhe o que você andou.',
];
/**
 * O mote do mês pedido (1 a 12).
 *
 * Mês fora da faixa devolve a frase do primeiro: o motor nunca deixa a divisória
 * sem mote, e um mês inventado por engano sai com texto em vez de sair em branco.
 */
export function moteDoMes(mes) {
    return MOTES_DO_MES[mes - 1] ?? MOTES_DO_MES[0];
}
//# sourceMappingURL=motes.js.map